import { useCallback, useEffect, useState } from "react";
import { createMetrics, updateMetrics } from "../service/service";
import { useAppGlobalConfig } from "../providers/AppGlobalConfigContext";
import { getUserId, getWizmeId } from "../helpers/user";
import { getMetricsWithFallback } from "../helpers/progressFallback";

/**
 * Hook to register the user's progress in a lesson.
 *
 * @param {string} userId - Current User ID.
 * @param {string} blockId - Content block ID.
 * @param {string} lessonId - Lesson ID.
 * @param {string} sectionId - Section ID.
 * @param {string} section - Section name.
 * @param {number} index - Current progress index.
 * @param {number} totalIndexes - Total indexes in the lesson.
 * @param {string} template - Template type.
 */
export const useRegisterProgress = (
  blockId,
  lessonId,
  sectionId,
  section,
  index,
  totalIndexes,
  template,
) => {
  const [metrics, setMetrics] = useState(null);
  const [initTime, setInitTime] = useState(Date.now());
  const { isEmbedMode } = useAppGlobalConfig();
  const currentBookName = JSON.parse(localStorage.getItem("currentBookName"));
  let tenant = isEmbedMode ? "cupheadless" : "cupfranchise";

  useEffect(() => {
    getMetricsData();
  }, [index]);

  const registerProgress = async (
    isRight = true,
    accuracy = 100,
    totalAttempts = 1,
  ) => {
    const userId = await getUserId();
    const platformId = await getWizmeId();

    const params = {
      userId: userId,
      platformId: platformId,
      blockId: blockId,
      template: template,
      bookName: currentBookName,
      lessonId: lessonId,
      scores: [
        {
          isRight: isRight,
          accuracy: accuracy,
          elapsedTime: Date.now() - initTime,
          dateTime: new Date(initTime).toISOString(),
          totalAttempts: totalAttempts,
        },
      ],
      sectionId: sectionId,
      section: section,
      index: index,
      totalIndexes: totalIndexes,
    };

    const updateMetricsPromise = metrics
      ? updateMetrics(params, tenant)
      : createMetrics(params, tenant);

    await updateMetricsPromise
      .then(() => {
        console.log("Metrics successfully updated.");
      })
      .catch((error) => {
        console.error("Error updating metrics:", error);
      });
  };

  const getMetricsData = useCallback(async () => {
    try {
      const platformId = await getWizmeId();

      const resp = await getMetricsWithFallback(platformId, blockId, tenant);
      if (resp.data) {
        setMetrics(resp.data);
      }
    } catch (error) {
      if (error.response && error.response.status === 404) {
        setMetrics(null);
      } else {
        console.error("Erro ao buscar métricas:", error);
      }
    }
  }, [index]);

  return { registerProgress };
};
